/**
 *
 * Asynchronously loads the component for Faqs
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
